export default __webpack_public_path__ + "static/media/user.4e1103b4.jpg";